export const INTRO_CONSTANTS = {
  title: "Integrated NOC, SOC & IT Helpdesk Services",
  text: "OneMind delivers a fully managed suite of Network Operations Center (NOC), Security Operations Center (SOC), and IT Helpdesk services—designed to keep your infrastructure running smoothly, securely, and without disruption. Together, these services strengthen your organization’s IT resilience—reducing risk, increasing uptime, and supporting seamless day-to-day operations.",
};
